import { useState } from 'react';
import { useLang } from '../../../i18n/LanguageContext';

const faqs = [
  {
    id: 1,
    questionEn: 'I have no prior experience. Can I still take these courses?',
    questionZh: '我没有任何基础，可以报名学习吗？',
    answerEn: 'Absolutely! Our curriculum is designed from the ground up for complete beginners. Every course has a full beginner-to-advanced learning path. Professional instructors provide personalized guidance based on your progress to ensure every student builds a solid foundation.',
    answerZh: '当然可以！我们的课程体系专为零基础学员设计，每门课程都有完整的从入门到进阶的学习路径。专业导师会根据您的进度提供个性化指导，确保每位学员打好扎实基础。',
  },
  {
    id: 2,
    questionEn: 'Are courses online or in-person?',
    questionZh: '课程是线上还是线下？',
    answerEn: 'Our courses are offered in two formats: online and in-person. Online courses include scheduled live sessions and on-demand recordings available at any time. In-person courses emphasize immersive practice and authentic hands-on experience.',
    answerZh: '我们的课程分为线上与线下两种类型：部分课程以线上进行，包含定时直播与不限时回放；部分课程则在线下开展，更注重沉浸式实践与真实体验。',
  },
  {
    id: 4,
    questionEn: 'What careers can I pursue after completing a course?',
    questionZh: '完成课程后可以从事哪些职业？',
    answerEn: 'Graduates can work as tarot readers, astrology consultants, energy healers, crystal healing practitioners, and more. We also offer entrepreneurship guidance to help you open your own studio. Many of our alumni have successfully launched their own mystical arts businesses.',
    answerZh: '毕业生可从事塔罗师、占星顾问、能量疗愈师、水晶疗愈师等职业。我们还提供创业指导，许多学员已成功创办了自己的神秘学事业。',
  },
  {
    id: 6,
    questionEn: 'What support is available if I have questions during my studies?',
    questionZh: '学习过程中遇到问题有哪些支持？',
    answerEn: 'We provide comprehensive learning support, with instructors available at any time to answer course-related questions. We also have an active student community where you can exchange insights and grow together with fellow learners.',
    answerZh: '我们提供全方位学习支持，导师会随时解答课程的相关问题。我们还有活跃的学员群，可与同学交流心得、共同成长。',
  },
];

export default function FAQ() {
  const [openId, setOpenId] = useState<number | null>(null);
  const { t } = useLang();

  return (
    <section id="faq" className="relative py-24 px-4 sm:px-8">
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-1 space-y-6">
            <h2 className="text-4xl sm:text-6xl font-serif text-white leading-tight">FAQ</h2>
            <p className="text-[#c8b6ff] text-lg">{t('Find answers quickly', '快速找到答案')}</p>

          </div>

          <div className="lg:col-span-3 space-y-4">
            {faqs.map((faq) => (
              <div
                key={faq.id}
                className={`bg-[#2d1b4e]/70 backdrop-blur-md rounded-2xl border transition-all duration-300 cursor-pointer ${
                  openId === faq.id
                    ? 'border-[#d4af37] shadow-lg shadow-[#d4af37]/20 bg-[#2d1b4e]/90'
                    : 'border-[#d4af37]/20 hover:border-[#d4af37]/40'
                }`}
                onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
              >
                <div className="flex items-center justify-between p-4 sm:p-6">
                  <h3 className="text-base sm:text-lg font-semibold text-white pr-4">{t(faq.questionEn, faq.questionZh)}</h3>
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className={`text-2xl text-[#d4af37] transition-transform duration-300 ${openId === faq.id ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </div>
                </div>
                <div className={`overflow-hidden transition-all duration-300 ${openId === faq.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}>
                  <div className="px-4 sm:px-6 pb-4 sm:pb-6 pl-6 sm:pl-8">
                    <p className="text-[#c8b6ff] leading-relaxed text-sm sm:text-base">{t(faq.answerEn, faq.answerZh)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}